import { render } from "./AdultsLanding.vue?vue&type=template&id=a148b090&scoped=true"
import script from "./AdultsLanding.vue?vue&type=script&lang=js"
export * from "./AdultsLanding.vue?vue&type=script&lang=js"

import "./AdultsLanding.vue?vue&type=style&index=0&id=a148b090&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a148b090"]])

export default __exports__